import {useMe} from "../../../hooks/useGetUser";
import AddIcon from "../../../images/icons/addIcon";
import ProfileBanner from "../../components/Profile/Banner";
import Loader from "../../components/shared/Loader";
import {useCallback, useEffect, useState} from "react";
import {
  AddBancModal,
  ViewBancModal,
} from "../../components/Profile/BancModal";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import BancDropDown from "../../components/Profile/BancDropDown";
import TickIcon from "../../../images/icons/tickIcon";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {bancApi} from "../../../services/technicianService";
import {showToastModal} from "../../components/shared/ToastModalSwal";

const BANK_VERIFICATION_PENDING_KEY = "stripe_bank_verification_pending";

const BancDetails = () => {
  const {data, isLoading, isError, error, refetch} = useMe();
  const [show, setShow] = useState(false);
  const [openViewMod, setOpenViewMod] = useState(false);
  const [connectStatus, setConnectStatus] = useState(null);
  const [connectLoading, setConnectLoading] = useState(false);
  const [connectError, setConnectError] = useState("");

  const [selectedBanc, setSelectedBanc] = useState();
  const {onUpdateTech} = useUpdateTechnician();

  // const {} = useUpdateTechnician();

  useEffect(() => {
    const banque = data?.Technician?.BankAccounts.find((el) => el.isSelected);
    if (!!banque) setSelectedBanc(banque);
  }, [data]);

  const loadConnectStatus = useCallback(async () => {
    try {
      setConnectError("");
      setConnectStatus(await bancApi.getConnectStatus());
    } catch (error) {
      setConnectError(
        error?.response?.data?.error
          || "Impossible de vérifier l'activation Stripe.",
      );
    }
  }, []);

  const finishBankVerification = useCallback(async () => {
    let latestStatus = null;
    for (let attempt = 0; attempt < 5; attempt += 1) {
      latestStatus = await bancApi.getConnectStatus();
      setConnectStatus(latestStatus);
      if (latestStatus?.bankAccountValidated) break;
      if (attempt < 4) {
        await new Promise((resolve) => window.setTimeout(resolve, 1000));
      }
    }

    if (latestStatus?.bankAccountValidated) {
      sessionStorage.removeItem(BANK_VERIFICATION_PENDING_KEY);
      showToastModal({
        success: true,
        title: "Compte bancaire validé",
        message: "Votre compte bancaire a été créé et validé par Stripe.",
      });
      refetch();
    } else {
      showToastModal({
        success: false,
        title: "Vérification incomplète",
        message:
          "La vérification Stripe n'est pas terminée. Reprenez la vérification pour finaliser votre compte bancaire.",
      });
    }
    window.history.replaceState({}, "", window.location.pathname);
  }, [refetch]);

  const startConnectOnboarding = useCallback(async (purpose = "onboarding") => {
    try {
      setConnectLoading(true);
      setConnectError("");
      const onboarding = await bancApi.startConnectOnboarding(purpose);
      if (onboarding?.url) {
        window.location.assign(onboarding.url);
        return;
      }
      setConnectStatus(onboarding);
    } catch (error) {
      setConnectError(
        error?.response?.data?.error
          || "Impossible de démarrer l'activation Stripe.",
      );
    } finally {
      setConnectLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!data?.Technician) return;
    const params = new URLSearchParams(window.location.search);
    const isBankVerification =
      params.get("bank_verification") === "1"
      || sessionStorage.getItem(BANK_VERIFICATION_PENDING_KEY) === "1";
    if (params.get("stripe_connect") === "refresh") {
      startConnectOnboarding("onboarding");
    } else if (
      params.get("stripe_connect") === "return"
      && isBankVerification
    ) {
      finishBankVerification().catch((error) => {
        setConnectError(
          error?.response?.data?.error
          || "Impossible de confirmer la vérification Stripe.",
        );
      });
    } else if (isBankVerification) {
      finishBankVerification().catch(() => {});
    } else {
      loadConnectStatus();
    }
  }, [
    data?.Technician,
    finishBankVerification,
    loadConnectStatus,
    startConnectOnboarding,
  ]);

  useEffect(() => {
    const verifyAfterStripeDashboard = () => {
      if (
        sessionStorage.getItem(BANK_VERIFICATION_PENDING_KEY) === "1"
        && !new URLSearchParams(window.location.search).get("stripe_connect")
      ) {
        finishBankVerification().catch(() => {});
      }
    };
    window.addEventListener("pageshow", verifyAfterStripeDashboard);
    return () => window.removeEventListener("pageshow", verifyAfterStripeDashboard);
  }, [finishBankVerification]);

  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  const payementFreq = [
    {label: "Par intervention", id: "Intervention"},
    {label: "Par quinzaine", id: "Two-weeks"},
    {label: "Par mois", id: "Month"},
  ];
  return (
    <>
      <AddBancModal show={show} setShow={setShow} />
      <ViewBancModal
        show={openViewMod}
        setShow={setOpenViewMod}
        banc={selectedBanc}
      />

      {/* <PageTitle activeMenu="Mon profil" /> */}
      <div className="w-full flex flex-col px-1 lg:grid lg:grid-cols-4 gap-4">
        <ProfileBanner />

        <div className="col-span-4 w-full ">
          <div className="card">
            <div className="card-body">
              <div className="flex w-full flex-col justify-start">
                <div className="flex w-full justify-between items-center pr-3">
                  <div className="text-left font-bold text-xl text-[#19295C]  ">
                    Coordonnées bancaires
                  </div>
                  <div
                    onClick={() => {
                      setShow(true);
                    }}
                    className="flex justify-center gap-2 items-center w-fit !px-4 !py-3 bg-[#FF6600]  rounded-lg  cursor-pointer "
                  >
                    <AddIcon className="h-6 w-6 fill-white" />
                    <div className=" m-0 text-sm text-white">
                      Ajouter{" "}
                      <span className="hidden sm:inline-block">un compte</span>
                    </div>
                    {/* Ajouter une zone d'intervention */}
                  </div>
                </div>
                <div className="w-full !py-5 !px-3 sm:!p-5">
                  <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-x-4  w-full  gap-y-4 flex-wrap justify-start">
                    {!data?.Technician?.BankAccounts?.length
                      ? "Veuillez ajouter vos coordonnées bancaires"
                      : data?.Technician?.BankAccounts?.map((banc) => (
                          <div className="w-full  px-2 flex justify-center ">
                            <div
                              className={`border-2 cursor-pointer relative border-solid  rounded-xl w-full  flex flex-col gap-2 p-3 justify-center items-start    ${
                                banc?.isSelected
                                  ? "bg-[#EEF6FF] border-[#1A64B9]"
                                  : ""
                              }`}
                              key={banc.id}
                              // onClick={() => {
                              //   if (!banc.isSelected) {
                              //     onUpdateBanc({
                              //       body: {isSelected: true},
                              //       id: banc.id,
                              //     });
                              //   } else {
                              //     return;
                              //   }
                              // }}
                              // onClick={() => handleBancClick(banc)}
                            >
                              {!!banc?.isSelected && (
                                <div className="absolute top-2 right-2 text-[#1A64b9] text-lg flex justify-center items-center rounded-full">
                                  <i className="fi fi-ss-check-circle"></i>
                                </div>
                              )}
                              <div className="absolute bottom-2 right-2">
                                <BancDropDown
                                  banc={banc}
                                  className=" w-8 h-8 "
                                  selected={banc?.isSelected}
                                  setOpenViewMod={setOpenViewMod}
                                  setSelectedBanc={setSelectedBanc}
                                />
                              </div>
                              <div className="flex items-center justify-start gap-3">
                                <div className=" w-6 flex justify-center items-center bg-[#1A64b9] rounded-md text-white aspect-square text-sm">
                                  <i className="fi fi-rr-bank flex items-center"></i>
                                </div>
                                <div
                                  title={banc.bankName}
                                  className="uppercase text-lg font-medium text-[#19295C] truncate "
                                >
                                  {banc.bankName}
                                </div>
                              </div>
                              <div
                                title={banc.iban}
                                className="uppercase text-sm truncate w-[95%]"
                              >
                                {banc.iban}
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
                {!!data?.Technician?.BankAccounts?.length && (
                  <div className="mx-3 mb-5 rounded-xl border border-solid border-[#D7E4F5] bg-[#F7FAFF] p-4">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <div className="font-semibold text-[#19295C]">
                          Virements Stripe
                        </div>
                        <div className="mt-1 text-sm text-[#5D6475]">
                          {connectStatus?.bankAccountValidated
                            ? "Votre compte est activé et peut recevoir les virements."
                            : connectStatus?.status === "PENDING"
                              ? "Stripe vérifie vos informations. Vous pouvez rouvrir le formulaire pour les compléter."
                              : "Activez votre compte sécurisé Stripe pour recevoir vos paiements."}
                        </div>
                        {!!connectError && (
                          <div className="mt-2 text-sm text-red-600">
                            {connectError}
                          </div>
                        )}
                      </div>
                      {connectStatus?.bankAccountValidated ? (
                        <div className="whitespace-nowrap rounded-lg bg-green-100 px-4 py-2 text-sm font-semibold text-green-700">
                          Compte activé
                        </div>
                      ) : (
                        <button
                          type="button"
                          disabled={connectLoading}
                          onClick={() => startConnectOnboarding(
                            connectStatus?.ready
                              ? "bank_account_update"
                              : "onboarding",
                          )}
                          className="whitespace-nowrap rounded-lg border-0 bg-[#1A64B9] px-4 py-3 text-sm font-semibold text-white disabled:opacity-60"
                        >
                          {connectLoading ? "Ouverture…" : "Activer mes virements"}
                        </button>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex w-full justify-start pr-3">
                  <div className="text-left font-bold text-xl text-[#19295C]  ">
                    Fréquence de paiement{" "}
                  </div>
                </div>
                <div className="w-full !py-5 !px-3 sm:!p-5">
                  <div className="flex w-full  gap-y-4 flex-wrap justify-start">
                    {payementFreq?.map((freq) => (
                      <div
                        className="w-full md:w-3/4 xl:w-1/4 px-2 flex justify-center  "
                        key={freq.id}
                      >
                        <div
                          className={`border-[1.5px] relative border-solid  !rounded-lg w-full  flex flex-col gap-2 !p-2 justify-center items-start    ${
                            data?.Technician?.paymentFrequency === freq.id
                              ? " border-[#1A64B9] bg-[#EEF6FF] text-[#1A64B9]"
                              : ""
                          }`}
                          key={freq.id}
                          // onClick={() => handleBancClick(banc)}
                        >
                          <div
                            className="flex items-center justify-between gap-3 w-full text-sm font-semibold cursor-pointer"
                            onClick={() => {
                              onUpdateTech({
                                id: data?.Technician?.id,
                                body: {paymentFrequency: freq.id},
                              });
                            }}
                          >
                            <div
                              className={`${
                                data?.Technician?.paymentFrequency === freq.id
                                  ? "font-semibold"
                                  : "font-normal"
                              }`}
                            >
                              {freq.label}
                            </div>
                            {data?.Technician?.paymentFrequency === freq.id && (
                              <div
                                className={`rounded-full  w-5 aspect-square cursor-pointer bg-[#1A64B9] flex justify-center items-center`}
                              >
                                <TickIcon className="stroke-[#fff] w-4 aspect-square " />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BancDetails;
